import React from "react";
import type { Category } from "@meupedaco/shared";
import { CrudPage } from "../../components/CrudPage";

export const CategoriesPage: React.FC = () => {
  const kindLabels: Record<string, string> = {
    INCOME: "Receita",
    EXPENSE: "Despesa",
    TAX: "Imposto",
    GENERAL: "Geral",
    CAPITAL: "Capital",
  };

  return (
    <CrudPage<Category>
      title="Categorias financeiras"
      endpoint="/modules/categories"
      searchPlaceholder="Buscar por nome ou codigo..."
      columns={[
        { label: "Codigo", render: (item) => item.code ?? "-" },
        { label: "Categoria", render: (item) => item.name },
        { label: "Tipo", render: (item) => kindLabels[item.kind] ?? item.kind },
      ]}
      formFields={[
        { name: "code", label: "Codigo", type: "text" },
        { name: "name", label: "Nome", type: "text", required: true },
        {
          name: "kind",
          label: "Tipo",
          type: "select",
          options: [
            { value: "INCOME", label: "Receita" },
            { value: "EXPENSE", label: "Despesa" },
            { value: "TAX", label: "Imposto" },
            { value: "GENERAL", label: "Geral" },
            { value: "CAPITAL", label: "Capital (Patrimonial)" },
          ],
        },
      ]}
      initialValues={{
        code: "",
        name: "",
        kind: "GENERAL",
      }}
      mapToPayload={(values) => ({
        code: values.code || null,
        name: values.name,
        kind: values.kind || "GENERAL",
      })}
      permissionWrite="CATEGORY_WRITE"
    />
  );
};
